var exports = {
  "iE": "xaee3c4fa--116c83--wrapper",
  "vR": "xaee3c4fa--116c83--tabs",
  "DD": "xaee3c4fa--116c83--title",
  "A1": "xaee3c4fa--116c83--_active",
  "LV": "xaee3c4fa--116c83--tabs-content",
  "kt": "xaee3c4fa--116c83--tab-content",
};

module.exports = exports;
